import { computed } from "vue";
import { TEMPLATE_KEYS } from "@/templates/_core/templateTypes";
import { useSiteTemplate } from "@/composables/useSiteTemplate";

export function useJapanStyleSite() {
  const {
    currentSiteInfo,
    currentStoreInfo,
    currentStorePageInfo,
    templateContext,
    templateKey,
  } = useSiteTemplate();

  const isJapanStyle = computed(() => {
    return templateKey.value === TEMPLATE_KEYS.JAPAN;
  });

  return {
    currentSiteInfo,
    currentStoreInfo,
    currentStorePageInfo,
    japanStyleConfig: templateContext,
    isJapanStyle,
  };
}
